module.exports = __webpack_public_path__ + "img/f2-2.47710814.jpg";